import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeDuration'
})
export class TimeDurationPipe implements PipeTransform {
  constructor(public translate: TranslateService) {}
  transform(date: string): any {
    if (!date) {
      return null;
    } else {
      const notificationDate = new Date(date + ' UTC').getTime();
      return this.timeAgo(notificationDate);
      
    }
  }

  timeAgo(date: any): any {
    const seconds = (new Date().getTime() - date) / 1000;
  
    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      return interval + ' ' + (interval === 1 ? this.translate.instant('notifications.year') : this.translate.instant('notifications.years')) + ' ' + this.translate.instant('notifications.ago');
    }
  
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval + ' ' + (interval === 1 ? this.translate.instant('notifications.month') : this.translate.instant('notifications.months')) + ' ' + this.translate.instant('notifications.ago');
    }
  
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval + ' ' +  (interval === 1 ? this.translate.instant('notifications.day') : this.translate.instant('notifications.days')) + ' ' +  this.translate.instant('notifications.ago');
    }
  
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval + ' ' +  (interval === 1 ? this.translate.instant('notifications.hour') : this.translate.instant('notifications.hours')) + ' ' +  this.translate.instant('notifications.ago');
    }
  
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval + ' ' +  (interval === 1 ? this.translate.instant('notifications.minute') : this.translate.instant('notifications.minutes')) + ' ' +  this.translate.instant('notifications.ago');
    }
  
    if(seconds < 10) return this.translate.instant('notifications.just_now');
  
    return Math.floor(seconds) + ' ' +  this.translate.instant('notifications.seconds') + ' ' + this.translate.instant('notifications.ago');
  };
}
